// extracted by mini-css-extract-plugin
export default {"saleRent":"SaleRent_saleRent__zTH0U","sale":"SaleRent_sale__ECU8w","rent":"SaleRent_rent__f96EV"};